export const contentData = {
  spanish:{
    layout:{
      title:'Infonavit',
      navigation:[
          {name:'Tablas de Control',path:'/controltables'},
          {name:'Detalles',path:'/controltables/details/:id'},
      ],
      menu:null
    },
    modals:{
      warning_delete_file:{
        title:'¿Estás seguro?',
        message:'¿Realmente quieres eliminar este registro? Este proceso no puede ser revertido',
        cancelButton:'Cancelar',
        deleteButton:'Eliminar'
      },
      edit_service:{
        title:'Editar servicio',
        button:'Guardar',
        cancelButton:'Cancelar'
      }
    },
    basicform:{
      title:'Información',
      button:null,
      nodata:'Sin Registro',
      headers:{
        fixedHeaderA: ['Nombre','RFC','Estatus','Clasificación','Regimen Fiscal',
        'Límite de Trabajadores'],
        fixedHeaderB: ['Estado','Registro Patronal','Ciudad','Usuario IDSE','Contraseña IDSE',
        'Certificado Digital IDSE','Contraseña Certificado Digital IDSE','Contraseña SIPARE',
        'Contraseña SUA', 'Contraseña Usuario Infonavit','Email Alta Infonavit'],
        varHeader: ['Fecha Límite de Presentación','Hoja de Trabajo','Línea de Captura',
        'Proceso','Estatus','Información Atención al Cliente 1','Información Atención al Cliente 2',
        'Cantidad a Pagar','Recargos y Actualizaciones','Total a Pagar','Línea Captura IMSS Infonavit',
        'Fecha Límite de Pago','Respuesta Cliente', 'Comentario Cliente','Responsable','Notas',
        'Horas Extra', 'Comprobante Horas', 'Cargos Extra', 'Comprobante Cargo', 
        'Cargo a Cobranza', 'Fecha de Completado'],
        extra: 'Completado'
      },

    }
  }
}
